/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

import { CardColorProps } from '../BaseIcon'

export const Mastercard: FunctionComponent<CardColorProps> = ({ blackAndWhite = false }) => (
  <React.Fragment>
    {!blackAndWhite && (
      <React.Fragment>
        <rect width='40' height='24' rx='2' fill='#fff' />
        <path d='M23.34 6.5h-6.68v11h6.68v-11Z' fill='#FF5F00' />
        <path
          d='M17.35 12A7.03 7.03 0 0 1 20 6.5 6.91 6.91 0 0 0 9.82 8.29a7.04 7.04 0 0 0 2.85 10A6.9 6.9 0 0 0 20 17.5a6.98 6.98 0 0 1-2.65-5.5Z'
          fill='#EB001B'
        />
        <path
          d='M30.57 16.34v-.23h.1v-.05h-.23v.05h.09v.23h.04Zm.45 0v-.28h-.07l-.09.2-.08-.2h-.07v.28h.05v-.2l.08.17h.05l.08-.18v.2h.05Zm.21-4.34a7.04 7.04 0 0 1-3.9 6.3 6.9 6.9 0 0 1-7.33-.8 6.99 6.99 0 0 0 1.95-8.56A6.99 6.99 0 0 0 20 6.5 6.91 6.91 0 0 1 31.23 12Z'
          fill='#F79E1B'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M38 1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM2 0a2 2 0 0 0-2 2v20c0 1.1.9 2 2 2h36a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z'
          fill='#F0F0F0'
        />
      </React.Fragment>
    )}
    {blackAndWhite && (
      <React.Fragment>
        <g clipPath='url(#mastercard-v1-a)'>
          <rect width='40' height='24' rx='2' fill='#fff' />
          <path d='M23.34 6.5h-6.68v11h6.68v-11Z' />
          <path
            d='M17.35 12A7.03 7.03 0 0 1 20 6.5 6.91 6.91 0 0 0 9.82 8.29a7.04 7.04 0 0 0 2.85 10A6.9 6.9 0 0 0 20 17.5a6.98 6.98 0 0 1-2.65-5.5Z'
            stroke='#fff'
            strokeWidth='.5'
          />
          <path d='M30.57 16.34v-.23h.1v-.05h-.23v.05h.09v.23h.04Zm.45 0v-.28h-.07l-.09.2-.08-.2h-.07v.28h.05v-.2l.08.17h.05l.08-.18v.2h.05Z' />
          <path
            d='M31.23 12a7.04 7.04 0 0 1-3.9 6.3 6.9 6.9 0 0 1-7.33-.8 6.99 6.99 0 0 0 1.95-8.56A6.99 6.99 0 0 0 20 6.5a6.91 6.91 0 0 1 10.18 1.79 7.04 7.04 0 0 1 1.05 3.7V12Z'
            stroke='#fff'
            strokeWidth='.5'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M38 1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM2 0a2 2 0 0 0-2 2v20c0 1.1.9 2 2 2h36a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z'
          />
        </g>
        <defs>
          <clipPath id='mastercard-v1-a'>
            <rect width='40' height='24' rx='2' fill='#fff' />
          </clipPath>
        </defs>
      </React.Fragment>
    )}
  </React.Fragment>
)
